import React from 'react'
import classes from './Card.module.css'
const Card = props =>{
    return(
        <div className={classes.container}>
            <div className={classes.imageContainer}>
                <img src={props.image} className={classes.image}/>
            </div>
            <div className={classes.contentContainer}>
    <p className={classes.heading}>{props.heading}</p>
    <p className={classes.content}>{props.content}</p>

            </div>
        </div>
    )
}
export default Card